// extracted by mini-css-extract-plugin
module.exports = {"inputText":"InputText_inputText__3zlKv","label":"InputText_label__2Zaqk","field":"InputText_field__2qbp4","invalid":"InputText_invalid__jatZF"};